import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      colors: {     brand: {
      50: "#f5e8f9",
      100: "#e2bdf0",
      200: "#ce91e6",
      300: "#b965db",
      400: "#a43ad1",
      500: "#662483", // sua cor principal
      600: "#521c68",
      700: "#3d154d",
      800: "#290d33",
      900: "#140619",
    }, }
    }
  }
});

const system = createSystem(defaultConfig, config);
export default system;
